const { ReviewTool } = require('review-tool');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.web.reviewTool', deps)
  .directive('reviewTool', reactDirective =>
    reactDirective(
      ReviewTool,
      [
        'clientId',
        'startDate',
        'endDate',
        'reviewing',
        'restoreLastChecks',
        'onReviewingChange',
        'ledgerId',
        'transactionId',
      ],
      {},
      {},
    ),
  );
